import { makeStyles, tokens, typographyStyles } from "@fluentui/react-components"

export const useStyles = makeStyles({
  container: {
    paddingLeft: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
    paddingBottom: tokens.spacingVerticalXXXL,
    height: "100%",
    overflowY: "auto",
  },
  headerSection: {
    marginBottom: tokens.spacingVerticalXXL
  },
  heading: {
    ...typographyStyles.title3,
    marginBottom: 0,
  },
  description: {
    ...typographyStyles.caption1,
    color: tokens.colorNeutralForeground3
  }
});

